import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

// Common Crumbs Subscription
export const CommonSubscriptionCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Iscrizioni',
    path: '/iscrizioni',
  },
];

// Foreign Residence Crumbs Subscription
export const ForeignResidenceCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: "Iscrizione AIRE per residenza all'estero",
    path: '/iscrizioni/residenza/estero',
  },
];

export const ResearchNotificationsSubscriptionCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Registrazioni SC - Anagrafe',
    path: '/iscrizioni/notifiche-da-stato-civile',
  },
];

export const DetailNotificationsSubscriptionCrumbs = [
  ...ResearchNotificationsSubscriptionCrumbs,
  {
    name: 'Dettaglio Registrazioni SC - Anagrafe',
    path: '/iscrizioni/notifiche-da-stato-civile/visualizza/:id/:idNotifica',
  },
];

export const EditNotificationsSubscriptionCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...ResearchNotificationsSubscriptionCrumbs,
    {
      name: 'Modifica Registrazioni SC - Anagrafe',
      path: goBackUrl,
    },
  ];
};

export const BirthNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionNotificationsResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsNonResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailNotificationsResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsNonResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathNotificationsResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationNotificationsResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsNonResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyNotificationsSubscriptionCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailNotificationsSubscriptionCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: `${goBackUrl}/convivenza/nascita`,
    },
  ];
};

export const SubscriptionSearchFamilyCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Persona - Iscrizione Nascita Famiglia',
    path: '/iscrizioni/famiglia',
  },
];

export const SubscriptionBirthFamilyCrumbs = [
  ...SubscriptionSearchFamilyCrumbs,
  {
    name: 'Iscrizione Nascita Famiglia',
    path: '/iscrizioni/famiglia/nascita',
  },
];

export const SubscriptionBirthNonResidentCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Iscrizione Nascita Non Residente',
    path: '/iscrizioni/non-residenti/nascita',
  },
];

export const SubscriptionSearchCohabitationCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Convivenza',
    path: '/iscrizioni/convivenza',
  },
];

export const SubscriptionBirthCohabitationCrumbs = [
  ...SubscriptionSearchCohabitationCrumbs,
  {
    name: 'Iscrizione Nascita Convivenza',
    path: '/iscrizioni/convivenza/nascita',
  },
];

export const BornSoloCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Iscrizione AIRE atto di nascita - Solo',
    path: '/iscrizioni/aire-nascita-solo',
  },
];

export const BornAggregazioneSearchCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Persona - Iscrizione AIRE atto di nascita',
    path: '/iscrizioni/aire-nascita-aggregazione',
  },
];

export const BornAggregazioneCrumbs = [
  ...BornAggregazioneSearchCrumbs,
  {
    name: 'Trascrizione',
    path: '/iscrizioni/aire-nascita-aggregazione/trascrizione',
  },
];

export const TransferNewSearchCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Persona - Iscrizione AIRE per trasferimento - Nuova famiglia',
    path: '/iscrizioni/aire-trasferimento-nuova',
  },
];

export const TransferNewCrumbs = [
  ...TransferNewSearchCrumbs,
  {
    name: 'Trasferimento',
    path: '/iscrizioni/aire-trasferimento-nuova/trasferimento',
  },
];

export const TransferAggregationSearchCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Persona - Iscrizione AIRE per trasferimento - Aggregazione a famiglia',
    path: '/iscrizioni/aire-trasferimento-aggregazione',
  },
];

export const TransferAggregationCrumbs = [
  ...TransferAggregationSearchCrumbs,
  {
    name: 'Trasferimento',
    path: '/iscrizioni/aire-trasferimento-aggregazione/trasferimento',
  },
];

export const CitizenshipNewSearchCrumbs = [...CommonSubscriptionCrumbs];

export const CitizenshipNewCrumbs = [
  ...CitizenshipNewSearchCrumbs,
  {
    name: 'Iscrizione AIRE per acquisto cittadinanza - Nuova famiglia',
    path: '/iscrizioni/aire-cittadinanza-nuova',
  },
];

export const CitizenshipAggregationSearchCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Ricerca Persona - Iscrizione AIRE per acquisto cittadinanza - Aggregazione a famiglia',
    path: '/iscrizioni/aire-cittadinanza-aggregazione',
  },
];

export const CitizenshipAggregationCrumbs = [
  ...CitizenshipAggregationSearchCrumbs,
  {
    name: 'Iscrizione AIRE per acquisto cittadinanza - Aggregazione a famiglia',
    path: '/iscrizioni/aire-cittadinanza-aggregazione/acquisto',
  },
];
